import { Controller } from "@hotwired/stimulus"
import { formatNumber } from "~/javascript/format_number"

const LABEL_COLOR = "#8A8984"
const SURFACE = "#FFFFFF"
const FORMATS = {
  usd: value => `$${formatNumber(value, 2)}`,
  number: value => formatNumber(value)
}

// One measure per day, stacked by tool on a single axis. The total goes in the tooltip.
export default class extends Controller {
  static targets = ["chart"]
  static values = { chartData: Object }

  loadChart() { return import("chart.js/auto") }

  async connect() {
    const connection = this.connection = {}
    try {
      const { Chart } = await this.loadChart()
      if (this.connection !== connection) return
      const { labels, datasets, format, total_label: totalLabel } = this.chartDataValue
      const formatValue = FORMATS[format]
      this.chart = new Chart(this.chartTarget, {
        type: "bar",
        data: {
          labels,
          datasets: datasets.map(dataset => ({
            label: dataset.label, data: dataset.data, backgroundColor: dataset.color,
            borderColor: SURFACE, borderWidth: { top: 2 }, borderSkipped: "bottom", maxBarThickness: 24
          }))
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: "index", intersect: false },
          plugins: {
            legend: { display: datasets.length > 1, position: "bottom", labels: { boxWidth: 9, boxHeight: 9, color: "#5F5E5A", font: { size: 11 } } },
            tooltip: {
              callbacks: {
                label: item => `${item.dataset.label}: ${formatValue(item.parsed.y)}`,
                footer: items => items.length > 1 ? `${totalLabel}: ${formatValue(items.reduce((sum, item) => sum + item.parsed.y, 0))}` : ""
              }
            }
          },
          scales: {
            x: { stacked: true, grid: { display: false }, border: { display: false }, ticks: { autoSkip: true, maxRotation: 0, color: LABEL_COLOR, font: { size: 10 } } },
            y: { stacked: true, beginAtZero: true, grid: { color: "#F1F1EF" }, border: { display: false },
                 ticks: { color: LABEL_COLOR, font: { size: 10 }, precision: format === "usd" ? 2 : 0, callback: value => formatValue(value) } }
          }
        }
      })
    } catch (error) {
      if (this.connection === connection) this.dispatch("error", { detail: { error } })
    }
  }

  disconnect() {
    this.connection = null
    this.chart?.destroy()
    this.chart = null
  }
}
